module.exports = __webpack_public_path__ + "static/media/muscoth_halwa.59a5c41c.jpg";